import React from 'react';
import {observer} from "mobx-react";
import {Prediction} from "../../../../../core/components/prediction/components/prediction";
import {ACTION_TYPES} from "../../../../../core/consts";
import {APP} from "../../../../../core/app/consts";
import {PartialGameViewModel} from "../../../../../domain/partial-game/models/partial-game-view-model";
import {PREDICTION_WIDGET} from "../../../../prediction-widget/predictions-widget.consts";
import {useBookieClick} from "../../../../../infrastructure/hooks/useBookieClick";

export const AthleteNextGamePredictionItemModule = observer(({
                                                               controller,
                                                               subSource,
                                                               prediction,
                                                               index,
                                                               betsImpressionParams
                                                             }) => {
  const {state} = controller;
  const {currentIndex, statusGroup, gameId, date, currentLinkModel, competitionId, showOdds} = state
  const {id, options, type, hasOdds, hasInsight, enableVoting, odds} = prediction;
  const isVisible: Boolean = currentIndex === index;

  const onVoteClick = (option) => controller.action(ACTION_TYPES.predictionClickEvent, {
    date,
    gameId,
    hasOdds,
    hasInsight,
    competitionId,
    num: option.num,
    key: option.vote.key,
    predictionId: id,
    status: statusGroup,
    currentLinkModelName: currentLinkModel.name,
    selectionsCount: options.length,
    marketType: type,
    source: APP.ANALYTICS.SOURCES.predictions,
    prediction,
    subSource
  });

  const showPrediction = () => controller.action(ACTION_TYPES.predictionShow, {
    entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[PartialGameViewModel.name] || null,
    screen: APP.ANALYTICS.SCREENS[currentLinkModel?.name],
    screenId: currentLinkModel.params.id || null,
    status: statusGroup,
    contextualUsed: false,
    source: APP.ANALYTICS.SOURCES.athleteNextGame
  });

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    hasOdds,
    urlLink: odds?.link,
    currentLinkModelName: currentLinkModel.name,
    entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[PartialGameViewModel.name],
    entityId: gameId,
    status: statusGroup,
    marketType: odds?.lineTypeId,
    bookieId: odds?.bookmaker.id,
    bookieName: odds?.bookmaker.name,
    widget: APP.GOOGLE_ANALYTICS.SOURCES.prediction,
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.odds,
    enableVote: enableVoting,
    source: APP.ANALYTICS.SOURCES.athleteNextGame,
    subSource: PREDICTION_WIDGET.TABS_LABEL.props
  });

  const onOddsClick = odds && odds?.link ? (num) => onBookieClick({
    actualBetOdd: odds?.rateOptions[num - 1]?.currentRate,
    buttonType: APP.ANALYTICS.BUTTON_TYPES_MAPPER[odds?.rateOptions.length][num],
  }) : null;

  const predictionProps = {
    prediction,
    showOdds,
    isVisible,
    controller,
    onOddsClick,
    onVoteClick,
    showPrediction,
    bookieHrefModel,
    betsImpressionParams,
    isAthletePage: true
  }

  return <Prediction {...predictionProps}/>
});